<template>
  <div></div>
</template>

<script>
  export default {
    components: {},
    data() {
      return {};
    }
  };
</script>
